(function () {
  'use strict';
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTabs);
  } else {
    initTabs();
  }

  function initTabs() {
    const parentSections = document.querySelectorAll('.bps-tabs-navigation');
    if (!parentSections.length) return;

    parentSections.forEach(function (nav) {
      const btns = nav.querySelectorAll('.bps-tab-btn');
      if (!btns.length) return;

      const dots = nav.querySelectorAll('.bps-tab-dot');
      const infoWrapper = nav.querySelector('.bps-tab-info-wrapper');
      const section = nav.closest('.best-products-deal');
      if (!section) return;

      const contentWrapper = section.querySelector('.bps-tabs-content');
      if (!contentWrapper) return;

      function switchTab(tabId) {
        if (!tabId) return;

        // Sync Buttons
        btns.forEach((b) => b.classList.toggle('active', b.getAttribute('data-tab') === tabId));

        // Sync Dots
        dots.forEach((d) => d.classList.toggle('active', d.getAttribute('data-tab') === tabId));

        const activeBtn = nav.querySelector(`.bps-tab-btn[data-tab='${tabId}']`);
        if (activeBtn) {
          const container = activeBtn.parentElement;
          if (container) {
            const rect = activeBtn.getBoundingClientRect();
            const containerRect = container.getBoundingClientRect();
            const scrollLeft = Math.max(0, container.scrollLeft + rect.left - containerRect.left - (containerRect.width / 2) + (rect.width / 2));
            try {
              container.scrollLeft = scrollLeft;
            } catch (err) {}
          }
        }

        // Sync Info
        if (infoWrapper) {
          infoWrapper.querySelectorAll('.bps-tab-info').forEach((info) => {
            info.classList.toggle('active', info.getAttribute('data-tab') === tabId);
          });
        }

        // Sync Panes
        contentWrapper.querySelectorAll('.bps-tab-pane').forEach((pane) => {
          const isActive = pane.getAttribute('data-tab') === tabId;
          pane.classList.toggle('active', isActive);

          // Reset slider on Valentine's / Mother's / Father's / Index / Search templates when switching tabs
          if (
            isActive &&
            (document.body.dataset.template === 'collection.valentines' ||
              document.body.dataset.template === 'collection.mother-day' ||
              document.body.dataset.template === 'collection.father-day' ||
              document.body.dataset.template === 'index' ||
              document.body.dataset.template === 'search')
          ) {
            const slider = pane.querySelector('slideshow-container.bps-deals-list');
            if (slider && slider.swiper) {
              requestAnimationFrame(() => {
                try {
                  slider.swiper.update();
                  if (typeof slider.swiper.slideTo === 'function' && slider.swiper.slides && slider.swiper.slides.length > 0) {
                    slider.swiper.slideTo(0, 0, 0);
                  }
                } catch (err) {}
              });
            }
          }
        });
      }

      btns.forEach((btn) => {
        btn.addEventListener('click', function (e) {
          if (e) e.preventDefault();
          const tabId = this.getAttribute('data-tab');
          switchTab(tabId);
        });
      });

      dots.forEach((dot) => {
        dot.addEventListener('click', function (e) {
          if (e) e.preventDefault();
          const tabId = this.getAttribute('data-tab');
          switchTab(tabId);
        });
      });
    });
  }
})();